import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";

import {
  getTransactionColumns,
  type Transactions
} from "./transactions-columns";
import { TransactionsDataTable } from "./transactions-data-table";

type TransactionsListProps = {
  data: Transactions[];
};

export const TransactionsList = ({
  data,
  isLoading
}: TransactionsListProps & { isLoading: boolean }) => {
  const { locale, timezone } = useCurrentTillLocalisation();

  const columns = getTransactionColumns({
    locale,
    timezone
  });

  return (
    <div className="w-full">
      <TransactionsDataTable
        columns={columns}
        data={data}
        isLoading={isLoading}
      />
    </div>
  );
};
